import React from 'react';

import { Divider } from 'Shared/components';

import { SMSConsent } from './SMSConsent';
import { SendESignaturePacket } from './SendESignaturePacket';
import { AgentConfirmation } from '../../MainContent/AgentConfirmation';
import { usePurchaseContext } from 'QuoteApp/services/providers';
import { VehicleSetup } from '../VehicleSetup';
import { SignatureStatus } from '../SignatureStatus';

import styles from './styles.module.css';

type ESignatureType = {
  eSignatureSMSConsent: boolean | undefined;
  documentSigningHandledByAgent: boolean;
  setESignatureSMSConsent: (consent: boolean) => void;
  policyDocumentsSigned: boolean;
  disableAgentSignatures: boolean;
};

export const ESignature = ({
  eSignatureSMSConsent,
  setESignatureSMSConsent,
  policyDocumentsSigned,
  documentSigningHandledByAgent,
  disableAgentSignatures,
}: ESignatureType) => {
  const { eSignatureSectionRef, vehiclePhotos } = usePurchaseContext();

  // Vehicle photos feature is only available for non-standard auto product segment
  const isNonStandardAutoProduct = !!vehiclePhotos?.dueDate;

  const renderSignatureStatus = () => {
    return (
      <div className={styles.signatureStatus} data-testid="signature-status">
        <SignatureStatus signed={policyDocumentsSigned} />
      </div>
    );
  };

  // Agent Signature 2.0
  const renderAgentSignature20 = () => {
    return (
      <>
        <SMSConsent
          eSignatureSMSConsent={eSignatureSMSConsent}
          setESignatureSMSConsent={setESignatureSMSConsent}
        />
        <SendESignaturePacket eSignatureSMSConsent={eSignatureSMSConsent} />
      </>
    );
  };

  const renderVehicleSetup = () => {
    return (
      <>
        <Divider />
        <VehicleSetup setupDueDate={vehiclePhotos?.dueDate || ''} />
      </>
    );
  };

  return (
    <div ref={eSignatureSectionRef}>
      {disableAgentSignatures ? (
        <div
          className={styles.customerDocuments}
          data-testid="customer-documents"
        >
          <h3>Customer Documents</h3>
          <p>
            Please ensure that all proper policy documentation is signed and
            processed within a timely manner to prevent disruptions in customer
            coverage.
          </p>
        </div>
      ) : (
        <>
          <h3>eSignature Required</h3>
          <p>
            To activate coverage, we require necessary documents to be sent to
            the customer for electronic signature. Without the required
            signature, the policy and/or certain coverage selections,
            necessitating a waiver, may not be in effect. If waivers are not
            received before the policy&apos;s effective date, coverage will be
            added at appropriate limits. If waived coverages are added to the
            policy, additional premium may be due and the amount will be debited
            from the payment method on file.
          </p>
          {documentSigningHandledByAgent
            ? renderSignatureStatus()
            : renderAgentSignature20()}
          {isNonStandardAutoProduct ? renderVehicleSetup() : null}
          <Divider />
        </>
      )}
      <AgentConfirmation />
    </div>
  );
};
